import { pathologiesDaughterSlug, pathologiesMotherSlug } from 'templates/Pathologies/utils/slugs'

export const data = [
  {
    categorySlug : "sante-sexuelle",
    icon: "menu-icons/colored-group.svg",
    name: 'Santé sexuelle',
    innerWording: "sexuelles",
    id: "sexualite-category",
    alt: "sexualité menu icon",
    title: "sexuality",
    classes: "inline-menu-category",
    to: pathologiesMotherSlug("sante-sexuelle"),
    items: [
      {
        name: "Problème d'érection",
        slug: 'problemes-erection',
        to: pathologiesDaughterSlug("sante-sexuelle", 'problemes-erection')
      },
      {
        name: 'Éjaculation précoce',
        slug: 'ejaculation-precoce',
        to: pathologiesDaughterSlug("sante-sexuelle", 'ejaculation-precoce')
      },
      {
        name: 'Baisse de libido',
        slug: 'baisse-de-libido',
        to: pathologiesDaughterSlug("sante-sexuelle", 'baisse-de-libido')
      },
      {
        name: 'Impuissance',
        slug: 'impuissance',
        to: pathologiesDaughterSlug("sante-sexuelle", 'impuissance')
      },
      {
        name: 'Troubles sexuels',
        slug: 'troubles-sexuels',
        to: pathologiesDaughterSlug("sante-sexuelle", 'troubles-sexuels')
      },
      {
        name: 'IST',
        slug: 'ist',
        to: pathologiesDaughterSlug("sante-sexuelle", 'ist')
      },
      {
        name: 'Bouton sur le pénis',
        slug: 'bouton-penis',
        to: pathologiesDaughterSlug("sante-sexuelle", 'bouton-penis')
      }
    ]
  },
  {
    categorySlug : "poids",
    icon: "menu-icons/colored-icon-poids.svg",
    name: 'Poids',
    id: "poids-category",
    alt: "poids menu icon",
    title: "weight",
    classes: "inline-menu-category menu-items-separation",
    to: pathologiesMotherSlug("poids"),
    items: [
      {
        name: "Perte de poids",
        slug: 'perte-de-poids',
        to: "https://poids.charles.co/",
      }
    ]
  },
  {
    categorySlug : "sommeil",
    icon: "menu-icons/colored-icon-sommeil.svg",
    name: 'Troubles du sommeil',
    innerWording: "du sommeil",
    id: "sommeil-category",
    alt: "sommeil menu icon",
    title: "sommeil",
    classes: "inline-menu-category menu-items-separation",
    to: pathologiesMotherSlug("sommeil"),
    items: [
      {
        name: 'Insomnie',
        slug: 'insomnie',
        to: pathologiesDaughterSlug("sommeil", 'insomnie')
      },
      {
        name: 'Troubles du sommeil',
        slug: 'troubles-du-sommeil',
        to: pathologiesDaughterSlug("sommeil", 'troubles-du-sommeil')
      },
      {
        name: 'Médecin du sommeil',
        slug: 'medecin-du-sommeil',
        to: pathologiesDaughterSlug("sommeil", 'medecin-du-sommeil')
      },
      {
        name: 'Somnolence',
        slug: 'somnolence',
        to: pathologiesDaughterSlug("sommeil", 'somnolence')
      },
      {
        name: 'Fatigue chronique',
        slug: 'fatigue-chronique',
        to: pathologiesDaughterSlug("sommeil", 'fatigue-chronique')
      },
      {
        name: 'Sueur nocturne',
        slug: 'sueur-nocturne',
        to: pathologiesDaughterSlug("sommeil", 'sueur-nocturne')
      }
    ]
  },
  {
    categorySlug : "fertilite",
    icon: "menu-icons/colored-icon-fertilite.svg",
    name: 'Fertilité masculine',
    innerWording: "de la fertilité",
    id: "fertilite-category",
    alt: "fertilite menu icon",
    title: "sommeil",
    classes: "inline-menu-category menu-items-separation",
    to: pathologiesMotherSlug("fertilite"),
    items: [
      {
        name: 'Spermogramme',
        slug: 'spermogramme',
        to: pathologiesDaughterSlug("fertilite", 'spermogramme')
      },
      {
        name: 'Fertilité homme',
        slug: 'fertilite-homme',
        to: pathologiesDaughterSlug("fertilite", 'fertilite-homme')
      },
      {
        name: 'Test de fertilité',
        slug: 'test-de-fertilite',
        to: pathologiesDaughterSlug("fertilite", 'test-de-fertilite')
      },
      {
        name: 'Azoospermie',
        slug: 'azoospermie',
        to: pathologiesDaughterSlug("fertilite", 'azoospermie')
      },
      {
        name: 'Spermocytogramme',
        slug: 'spermocytogramme',
        to: pathologiesDaughterSlug("fertilite", 'spermocytogramme')
      }
    ]
  },
  {
    name: 'Chute de cheveux',
    icon: "menu-icons/colored-icon-cheveux.svg",
    categorySlug : "cheveux",
    innerWording: "du cheveu",
    id: "hair-category",
    alt: "hair menu icon",
    title: "hair",
    classes: "inline-menu-category menu-items-separation",
    to: pathologiesMotherSlug("cheveux"),
    items: [
      {
        name: 'Perte de cheveux',
        slug: 'perte-de-cheveux',
        to: pathologiesDaughterSlug("cheveux", 'perte-de-cheveux')
      },
      {
        name: 'Calvitie',
        slug: 'calvitie',
        to: pathologiesDaughterSlug("cheveux", 'calvitie')
      },
      {
        name: 'Alopécie',
        slug: 'alopecie',
        to: pathologiesDaughterSlug("cheveux", 'alopecie')
      },
      {
        name: 'Pelade',
        slug: 'pelade',
        to: pathologiesDaughterSlug("cheveux", 'pelade')
      },
      {
        name: 'Pousse de cheveux',
        slug: 'pousse-de-cheveux',
        to: pathologiesDaughterSlug("cheveux", 'pousse-de-cheveux')
      },

    ]
  }, {
    name: 'Programmes digitaux',
    icon: "menu-icons/colored-icon-visio.svg",
    id: "therapy-category",
    alt: "therapy menu icon",
    title: "therapy",
    classes: "inline-menu-category menu-items-separation",
    to: null,
    items: [
      {
        name: 'Programme Éjaculation',
        slug: 'time',
        to: '/time/'
      },
      {
        name: 'Programme Érection',
        slug: 'master',
        to: '/master/'
      },
      {
        name: 'Programme Sommeil',
        slug: 'programme-sommeil',
        to: '/programme-sommeil/'
      }
    ]
  },
];
